import {gsap} from "gsap";

import TemplateContents from './TemplateContents';
import Carousel from './Carousel';

export default class extends Carousel {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();
  }

  initEvents() {
    super.initEvents();
  }

  clickNextHandler(event) {
    if (!this.enabled) return;
    let dr = .6;

    if (this.targetSwipeX <= this.minX) {
      // すでに最後 → 先頭へ
      this.pastSwipeX = this.targetSwipeX = 0;
    } else {
      this.pastSwipeX = this.targetSwipeX = Math.max(this.targetSwipeX - this.singleW * this.nextPrevNum, this.minX);
    }

    this.updatePrevNext();
    gsap.killTweensOf(this);
    gsap.to(this, dr, {
      swipeX: this.targetSwipeX, onUpdate: () => {
        this.updateCarousel();
        this.updateUI();
      }, ease: 'quart.out'
    });
  }

  clickPrevHandler(event) {
    if (!this.enabled) return;
    let dr = .6;

    if (this.targetSwipeX >= 0) {
      // すでに先頭 → 最後へ
      this.pastSwipeX = this.targetSwipeX = this.minX;
    } else {
      this.pastSwipeX = this.targetSwipeX = Math.min(this.targetSwipeX + this.singleW * this.nextPrevNum, 0);
    }

    this.updatePrevNext();
    gsap.killTweensOf(this);
    gsap.to(this, dr, {
      swipeX: this.targetSwipeX, onUpdate: () => {
        this.updateCarousel();
        this.updateUI();
      }, ease: 'quart.out'
    });
  }

  getCarouselWidth() {
    let w = 0;
    for (let i = 0, len = this.carouselChilds.length; i < len; i++) {
      let item = this.carouselChilds[i];
      let singleW = item.clientWidth;
      let marginRight = 0;
      // 表示されている（幅がある）場合のみマージンを取得して加算する
      if(singleW > 0){
        const style = window.getComputedStyle(item);
        marginRight = parseFloat(style.marginRight); // マージンを取得
      }
      singleW += marginRight;
      w += singleW;
    }

    return w;
  }

  start() {}

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
